import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { InspectionPoint, Inspection } from '../../shared/models/index';

@Component({
    selector: 'point-edit-notes',
    templateUrl: './edit-notes.component.html',
    standalone: false
})
export class PointEditNotesComponent implements OnInit {
  @Input() public point: InspectionPoint;
  @Input() public processing;
  @Output() public toggleSavePoint: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  editForm: UntypedFormGroup;
  inspection: Inspection;

  constructor() {}

  ngOnInit(): void {
    this.inspection = this.point.inspection;
    this.initForm();
  }

  public updatePoint(model: any) {
    this.point.notes = model.notes;
    this.toggleSavePoint.emit(this.point);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  initForm() {
    const regex = new RegExp(/<br\s*[\/]?>/gi);
    this.editForm = new UntypedFormGroup({
      notes: new UntypedFormControl(this.point.notes ? this.point.notes.replace(regex, '\n') : '')
    });
  }
}
